<div *ngIf="!isMinimized" class="ac-feature-flag-container">
	<div class="text-12 padding-10">Please select feature(s) you want to enable and click "apply"</div>
	<button class="ac-feature-flag-minimize-icon" (click)="isMinimized = !isMinimized">-</button>
	<div class="text-12 ac-feature-flag-option-container margin-horizontal-10 padding-vertical-10 padding-horizontal-5">
		<dz-checkbox *ngFor="let flag of allFlags" (change)="onToggleFlag(flag)" [checked]="selectedFlags.includes(flag)">{{ flagsName[flag] }} </dz-checkbox>
	</div>
	<div class="padding-10">
		<button dz-button (click)="applyFeatureFlag()">Apply</button>
		<button dz-button color="secondary" (click)="resetFeatureFlag()">Reset</button>
	</div>
</div>

<button *ngIf="isMinimized" class="ac-feature-flag-container-minimized" (click)="isMinimized = !isMinimized">
	<icon type="cog"></icon>
</button>
